import { Form } from 'antd-mobile'
import { observer, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect, useMemo } from 'react'

import NewEditForm from '@/components/NewEditForm'
import dictStoreNoContext from '@/store/global/dictStore'

import { Config, Category } from './enum'

interface TemplateGenerateProps {
  [key: string]: any
}

const TemplateGenerate: React.FC<TemplateGenerateProps> = (props) => {
  const {
    form,
    label,
    placeholder,
    required,
    disabled,
    fieldNames: { typeName, valueName } = {
      typeName: 'salary_details',
      valueName: 'salary_structure_template_id'
    },
    value
  } = props
  const currentForm = form
  const zidianStore = useLocalObservable(() => dictStoreNoContext)
  const templateId = Form.useWatch(typeName, currentForm)
  const formInfo: any = useMemo(() => {
    const options = zidianStore.dictMap.DictSalaryTemplate || []
    const typeItem = Config[Category.ChangeSalary]?.control?.({
      options,
      typeName,
      label,
      required,
      disabled,
      placeholder
    })[0]
    const optionItems =
      options
        .find((x: any) => x.id === templateId)
        ?.item_dtos?.filter((y: any) => y.base_item_flag) || []
    const values = value?.[valueName] || []
    const findValue = (code: string) => {
      return values?.find((x: any) => x.code === code)?.value
    }
    const valueItems =
      optionItems.map((x: any) => {
        return {
          type: 'InputNumber',
          elementProps: {
            min: 0,
            step: 1,
            precision: 0,
            placeholder: '请输入'
          },
          formItemProps: {
            initialValue: findValue(x.code),
            name: valueName ? [valueName, x.code] : x.code,
            label: x.name,
            required: required ?? true,
            disabled
          }
        }
      }) || []
    console.log('valueItems=', values)
    return [
      {
        form_list: [typeItem, ...valueItems]
      }
    ]
  }, [templateId, value, zidianStore.dictMap.DictSalaryTemplate])

  useEffect(() => {
    zidianStore.requestExtraDicts([Config[Category.ChangeSalary]?.dict])
  }, [])

  return <NewEditForm formInst={currentForm} formType='item' formInfo={formInfo} />
}

export default observer(TemplateGenerate)
